import { authGet } from "@api";
import { Organization } from "@types";

export const fetchOrganizations = (): Promise<Organization[]> => {
  return authGet<{ organizations: Organization[] }>(
    `/api/agent/organizations`
  ).then((result) => result.organizations);
};
